<button [class]="buttonClass" [style]="buttonStyle" kendoButton [disabled]="disabled || loading">
  @if (loading) {
    <kendo-loader class="me-1 loader" [size]="loaderSize"></kendo-loader>
  }
  <span>{{text}}</span>
</button>